import { Destination } from "../models/destination";
import { Location } from "../models/location";
import { DESTINATION, Mode, MODE } from "./enums";

export const getIconByModeOrDestination = (
  mode?: MODE | string,
  destination?: Destination,
  destinationResidence?: Location
) => {
  if (destination) {
    switch (destination?.name?.toLocaleLowerCase()) {
      case DESTINATION.NOT_GOING.toLocaleLowerCase():
        return "TiWarningOutline";
      case DESTINATION.AIR.toLocaleLowerCase():
        return "IoAirplaneOutline";
      case DESTINATION.SEA.toLocaleLowerCase():
        return "DirectionsBoatOutlinedIcon";
      case DESTINATION.ROAD.toLocaleLowerCase():
        return "RiTruckLine";
    }
  }
  if (mode) {
    switch (mode?.toLocaleLowerCase()) {
      case Mode.Road.toLocaleLowerCase():
        return "RiTruckLine";
      case Mode.Air.toLocaleLowerCase():
        return "IoAirplaneOutline";
      case Mode.Sea.toLocaleLowerCase():
        return "DirectionsBoatOutlinedIcon";
      default:
        return null;
    }
  }

  if (destinationResidence) {
    return "RiTruckLine";
  }

  return null;
};
